<template>
  <div class="card-msg flex flex-column">
    <template v-for="(item, index) in page.globalConfig" :key="index">
      <component :is="item.type" :item="item" @childMounted="handleChildMounted" />
    </template>
  </div>
</template>
<script setup>
import { reactive, defineProps, watch, computed, getCurrentInstance, defineEmits } from 'vue'
import previewModule from './components/preview'
import { replaceBraces, getStringsInBraces } from '@/utils/index'
import { ElMessage } from 'element-plus'
const componentsEnums = {
  101: 'YText',
  102: 'YTitle',
  103: 'YPicture',
  104: 'YDivider',
  201: 'YButton',
  202: 'YFoldSelect',
  203: 'YFoldButton',
  204: 'YTimeSelect',
  301: 'YTextButton',
  302: 'YTextPicture',
  303: 'YTextFoldSelect',
  304: 'YTextFoldButton',
  305: 'YTextTimeSelect',
  306: 'YTitleText',
  401: 'YCoupons',
  402: 'YRedPacket'
}
const props = defineProps({
  item: { type: Object, default: () => {} }
})
const model = computed(() => {
  return props.item.obj.model || {}
})
const { proxy } = getCurrentInstance()
const page = reactive({
  globalConfig: {}
})
const getTemplateInfo = async () => {
  let res = await proxy.$http.post(`/cs/cscardtemplate/info`, { templateId: props.item.obj.templateId })
  if (res.code === 0) {
    page.globalConfig = JSON.parse(res.data.globalConfig).map((i) => {
      i.type = previewModule[componentsEnums[i.type]]
      if (i.setting.text) {
        let arr = getStringsInBraces(i.setting.text)
        arr.forEach((j) => {
          i.setting.text = replaceBraces(i.setting.text, model.value[j])
        })
      }
      return i
    })
  } else {
    ElMessage.error(res.msg)
  }
}
const emit = defineEmits(['load'])
const handleChildMounted = () => {
  emit('load')
}
watch(
  () => props.item,
  () => {
    getTemplateInfo()
  },
  { immediate: true }
)
</script>
<style lang="less" scoped>
.card-msg {
  background: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(64, 158, 255, 0.1);
  border-radius: 10px;
  width: 243px;
  line-height: 1.2;
}
</style>
